module.exports = __webpack_public_path__ + "static/img/bottom_right.c19efd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom_right.png
// module id = DS+u
// module chunks = 1